export default {
  period: 'Periodo de análisis',
  mixMode: 'Modo del mix',
  progress: '{done} de {total} presupuestos calculados',
  kpi: 'KPI',
  delete: 'Eliminar',
  cancel: 'Cancelar',
  deleteTitle: 'Eliminar simulación de presupuesto',
  deleteConfirm: '¿Eliminar "{name}" y los planes de todos sus presupuestos? Esta acción no se puede deshacer.',
  waiting: 'Los presupuestos se están calculando. Los gráficos aparecen a medida que cada uno termina.',
  totalSaturationCurve: 'Curva de Saturación Total',
  roasByBudget: 'ROAS Total en distintos Niveles de Presupuesto',
  mixByBudget: 'Mix de Medios en distintos Niveles de Presupuesto',
  budgetLevel: 'Presupuesto',
  ofReference: '{pct}% de la referencia',
  // XLSX download
  xlsxSimulation: 'Simulación de presupuesto',
  xlsxGridBudgets: 'Presupuestos de la grilla ({unit})',
  xlsxPctOfReference: '% de la referencia',
  xlsxOptimalZones: 'Zonas Óptimas',
  xlsxZone: 'Zona',
  xlsxFrom: 'Desde',
  xlsxTo: 'Hasta',
  xlsxFrozenMix: 'Mix Fijo',
  xlsxShare: 'Participación (%)',
  xlsxPeriod: 'Periodo'
}
